import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AdminService } from '../../services/admin/admin.service';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css']
})
export class DeleteComponent implements OnInit {
  @Output() lista = new EventEmitter<boolean>();
  @Input() id_banner: number;

  constructor(
    public admin: AdminService,
    private _helper: HelpersService
  ) { }

  ngOnInit() {
  }

  delete() {
    this._helper.modalConfirm("¿Deseas eliminar este banner?")
      .then((willDelete) => {
        if (willDelete.value) {
          // Usar el nuevo método de eliminación con DELETE
          this.admin.deleteBanner(this.id_banner).subscribe({
            next: (response) => {
              this._helper.modalSuccess("Banner eliminado exitosamente");
              this.lista.emit(true);
            },
            error: (error) => {
              console.error('Error al eliminar banner:', error);
              this._helper.modalError('Error al eliminar el banner');
            }
          });
        }
      });
  }
}
